import React from "react";
import { FormattedMessage } from "react-intl";

import { FileType } from "~/common/constants";

import PatientFiles from "../../patient_files";

export function PatientCardCTFiles() {
  return (
    <div className="form-body" id="ct-media-block">
      {/* Match the other patient-card section headings and dividers. */}
      <h4 className="tw-mb-5 tw-mt-6 tw-border-t tw-border-[#E5E5E5] tw-pt-3 tw-text-2xl tw-font-normal tw-leading-[1.2] tw-text-foreground">
        <FormattedMessage id="UPLOADED_CBCT" />
      </h4>

      <PatientFiles type={FileType.DICOM} />
    </div>
  );
}
